module.exports = __webpack_public_path__ + "img/guache.f439416f.png";